import { BrowserRouter, Link, Navigate, Route, Routes, useParams } from 'react-router-dom';
import './App.css'; 
import { lazy, Suspense } from 'react';
import snapRoutes from './snap-routes.json';
import Spinner from './components/common_Components/Spinner.js';
import MainLayout from './components/layout/MainLayout.js';
import { Routing } from './components/shared/Routing.js';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "animate.css/animate.compat.css" 
import PrivateRoute from './components/common_Components/PrivateRoute.js';
import ScrollToTop from './components/common_Components/ScrollToTop.js';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './context/AuthContext.js';
const Homepage = lazy(() =>
  import("./components/pages/Home/Home.js")
);
const Product = lazy(() =>
  import("./components/pages/Product/Product.js")
);
const PremiumFreezeDried = lazy(() =>
  import("./components/pages/Product/PremiumFreezeDried.js")
);
const ProductDetailSwitcher = lazy(() =>
  import("./components/pages/ProductDetailSwitcher.js")
);
const Gallery = lazy(() =>
  import("./components/pages/gallery/Gallery.js")
);
const Contact = lazy(() =>
  import("./components/pages/contact/Contact.js")
);
const BlogDetails = lazy(() =>
  import("./components/pages/blog/BlogDetails.js")
);
const Blog = lazy(() =>
  import("./components/pages/blog/Blog.js")
);
const About = lazy(() =>
  import("./components/pages/about/About.js")
);
const Company = lazy(() =>
  import("./components/pages/company/Company.js")
);
const Cart = lazy(() =>
  import("./components/pages/cart/Cart.js")
);
const Wishlist = lazy(() =>
  import("./components/pages/wishlist/Wishlist.js")
);
const Checkout = lazy(() =>
  import("./components/pages/checkout/Checkout.js")
);
const Review = lazy(() =>
  import("./components/pages/Review/Review.js")
);
const ReviewDetails = lazy(() =>
  import("./components/pages/Review/ReviewDetails.js")
);
const Profile = lazy(() =>
  import("./components/pages/Profile/Profile.js")
);
const OrderDetail = lazy(() =>
  import("./components/pages/Profile/OrderDetails.js")
);
const OrderList = lazy(() =>
  import("./components/pages/Profile/OrderList.js")
);
const OrderSuccess = lazy(() =>
  import("./components/pages/Profile/OrderSuccess.js")
);
const PrivacyPolicy = lazy(() =>
  import("./components/pages/policies/PrivacyPolicy.js")
);
const ReturnsRefunds = lazy(() =>
  import("./components/pages/policies/ReturnsRefunds.js")
);
const TermsConditions = lazy(() =>
  import("./components/pages/policies/TermsConditions.js")
);
const FAQs = lazy(() =>
  import("./components/pages/faqs/FAQs.js")
);
const ShoppingFAQs = lazy(() =>
  import("./components/pages/faqs/ShoppingFAQs.js")
);
const AffiliateJoin = lazy(() =>
  import("./components/pages/affiliate/AffiliateJoin.js")
);

function LegacyUpcomingProductRedirect() {
  const { name } = useParams();
  return <Navigate to={`/product/${name}`} replace />;
}

function App() {
  const routes = [
    {
      path: Routing.Initial,
      component: Homepage,
      isPrivateRoute: false,
    },
    {
      path: Routing.Products,
      component: Product,
      isPrivateRoute: false,
    },
    {
      path: Routing.PremiumFreezeDried,
      component: PremiumFreezeDried,
      isPrivateRoute: false,
    },
    {
      path: Routing.Product_details,
      component: ProductDetailSwitcher,
      isPrivateRoute: false,
    },
    {
      path: Routing.Contact,
      component: Contact,
      isPrivateRoute: false,
    },
    {
      path: Routing.Gallery,
      component: Gallery,
      isPrivateRoute: false,
    },
    {
      path: Routing.Blog,
      component: Blog,
      isPrivateRoute: false,
    },
    {
      path: Routing.BlogDetails,
      component: BlogDetails,
      isPrivateRoute: false,
    },
    {
      path: Routing.Company,
      component: Company,
      isPrivateRoute: false,
    },
    {
      path: Routing.About,
      component: About,
      isPrivateRoute: false,
    },
    {
      path: Routing.Cart,
      component: Cart,
      isPrivateRoute: true,
    },
    {
      path: Routing.Wishlist,
      component: Wishlist,
      isPrivateRoute: true,
    },
    {
      path: Routing.Profile,
      component: Profile,
      isPrivateRoute: true,
    },
    {
      path: Routing.Checkout,
      component: Checkout,
      isPrivateRoute: true,
    },
    {
      path: Routing.Review,
      component: Review,
      isPrivateRoute: false,
    },
    {
      path: Routing.ReviewDetails,
      component: ReviewDetails,
      isPrivateRoute: false,
    },
    {
      path: Routing.OrderDetail,
      component: OrderDetail,
      isPrivateRoute: true,
    },
    {
      path: Routing.OrderList,
      component: OrderList,
      isPrivateRoute: true,
    },
    {
      path: Routing.OrderSuccess,
      component: OrderSuccess,
      isPrivateRoute: true,
    },
    {
      path: Routing.PrivacyPolicy,
      component: PrivacyPolicy,
      isPrivateRoute: false,
    },
    {
      path: Routing.ReturnsRefunds,
      component: ReturnsRefunds,
      isPrivateRoute: false,
    },
    {
      path: Routing.TermsConditions,
      component: TermsConditions,
      isPrivateRoute: false,
    },
    {
      path: Routing.FAQs,
      component: FAQs,
      isPrivateRoute: false,
    },
    {
      path: Routing.ShoppingFAQs,
      component: ShoppingFAQs,
      isPrivateRoute: false,
    },
    {
      path: Routing.AffiliateJoin,
      component: AffiliateJoin,
      isPrivateRoute: false,
    },
  ]; 

  return (
    <AuthProvider>
      <Suspense fallback={<Spinner />}>
        <BrowserRouter>
          {/* Hidden routes list for React Snap crawling */}
          {typeof window !== "undefined" && window.navigator && window.navigator.userAgent === "ReactSnap" && (
            <div style={{ display: 'none' }} aria-hidden="true" id="react-snap-crawl-routes">
              {snapRoutes.map((route) => (
                <a key={route} href={route}>{route}</a>
              ))}
            </div>
          )}
          <MainLayout>
            <ScrollToTop/>
            <Routes>
          <Route
            path="/upcoming_product_detals/:name"
            element={<LegacyUpcomingProductRedirect />}
          />
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                route.isPrivateRoute ? (
                  <PrivateRoute>
                    <route.component />
                  </PrivateRoute>
                ) : (
                  <route.component />
                )
              }
            />
          ))}
          <Route
            path="*"
            element={
              <>
                <main className="relative isolate min-h-full">
                  <img
                    alt="Page not found background - Nutrajun"
                    src="https://images.unsplash.com/photo-1545972154-9bb223aac798?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3050&q=80&exp=8&con=-15&sat=-75"
                    className="absolute inset-0 -z-10 h-full w-full object-cover object-top"
                  />
                  <div className="mx-auto max-w-7xl px-6 py-32 text-center sm:py-40 lg:px-8">
                    <p className="text-base font-semibold leading-8 text-white">
                      404
                    </p>
                    <h1 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-5xl">
                      Page not found
                    </h1>
                    <p className="mt-4 text-base text-white/70 sm:mt-6">
                      Sorry, we couldn't find the page you're looking for.
                    </p>
                    <div className="mt-10 flex justify-center">
                      <Link
                        to={Routing.Initial}
                        className="text-sm font-semibold leading-7 text-white"
                      >
                        <span aria-hidden="true">&larr;</span> Back to home
                      </Link>
                    </div>
                  </div>
                </main>
              </>
            }
          />
        </Routes>
      </MainLayout>
        </BrowserRouter>
        <ToastContainer/>
    </Suspense> 
    </AuthProvider>
  );
}

export default App;
